"use client";
import React, { useState } from "react";
import type { CSSProperties } from "react";
import TopNavThree from "../../../components/Header/TopNav/TopNavThree";
import MenuFurniture from "../../../components/Header/Menu/MenuFurniture";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import Footer from "../../../components/Footer/Footer";
import warning from "../../../utils/warning";
import axios from "axios";
import success from "../../../utils/success";
import { getApiUrl } from "../../../config/api";

const ContactUs = () => {
  document.title = "Contactez-Nous | Kissaria";

  const [Nom, setNom] = useState('')
  const [EmailTel, setEmailTel] = useState('')
  const [Message, setMessage] = useState('')
  const [LoadingSend, setLoadingSend] = useState(false)


  const handleSendMessage = (e: any)=> {
    e.preventDefault();
    setLoadingSend(true)
    if(Nom === '' || EmailTel === '' || Message === ''){
      warning("Veuillez remplir tous les champs obligatoires.");
    }

    axios.post(getApiUrl('CLIENT_SUBSCRIBE'), 
      { Nom, EmailTel, Message, isMessage: true }
    ).then((res)=> {
      if(res.data.isSend){
        success("Votre message a bien été reçu, vous serez contacté dès que possible")
        setNom('')
        setEmailTel('')
        setMessage("")
      } else {
        warning("Le message n’a pas été envoyé, le promoteur l’a réenvoyé");
      }
      setLoadingSend(false)
    }).catch((err)=> {
      warning("Le message n’a pas été envoyé, le promoteur l’a réenvoyé");
      setLoadingSend(false)
    })
  }

  return (
    <>
      <TopNavThree props="style-three bg-white" />
      <div id="header" className="relative w-full">
        <MenuFurniture props="" />
        <Breadcrumb heading="Contactez-Nous" subHeading="Contactez-Nous" />
      </div>
      <div className="contact-us md:py-20 py-10">
        <div className="container">
          <div className="flex justify-between max-lg:flex-col gap-y-10">
            <div className="fx-reveal left lg:w-2/3 lg:pr-4">
              <div className="heading3">Envoyez-nous un message</div>
              <div className="body1 text-secondary2 mt-3">
                Utilisez le formulaire ci-dessous pour entrer en contact avec
                l'équipe commerciale
              </div>
              <form onSubmit={(e)=> handleSendMessage(e)} className="md:mt-6 mt-4">
                <div className="grid sm:grid-cols-2 grid-cols-1 gap-4 gap-y-5">
                  <div className="name">
                    <input
                      className="border-line px-4 py-3 w-full rounded-lg"
                      id="username"
                      type="text"
                      placeholder="Votre Nom *"
                      onChange={(e)=> setNom(e.target.value)}
                      value={Nom}
                      required
                    />
                  </div>
                  <div className="email">
                    <input
                      className="border-line px-4 pt-3 pb-3 w-full rounded-lg"
                      id="emailouTel"
                      type="contact"
                      placeholder="Votre Email ou Numéro de Téléphone *"
                      onChange={(e)=> setEmailTel(e.target.value)}
                      value={EmailTel}
                      required
                    />
                  </div>
                  <div className="message sm:col-span-2">
                    <textarea
                      className="border-line px-4 pt-3 pb-3 w-full rounded-lg"
                      id="message"
                      rows={3}
                      placeholder="Votre Message *"
                      onChange={(e)=> setMessage(e.target.value)}
                      value={Message}
                      required
                    />
                  </div>
                </div>
                <div className="block-button md:mt-6 mt-4">
                  <button className="button-main transition-all duration-200 bg-pink hover:bg-greenprimary">
                    {
                      LoadingSend? "Les émetteurs sont en cours...": "Envoyer le message"
                    }
                  </button>
                </div>
              </form>
            </div>

            <div className="fx-reveal right lg:w-1/4 lg:pl-4" style={{ "--fx-delay": "100ms" } as CSSProperties}>
              <div className="item">
                <div className="heading4">Notre Magasin</div>
                <p className="mt-3">Sidi maarouf casablanca</p>
                <p className="mt-3">
                  Téléphone:{" "}
                  <span className="whitespace-nowrap">+212664045333</span>
                </p>
                <p className="mt-1">
                  Téléphone fixe:{" "}
                  <span className="whitespace-nowrap">+212521201115</span>
                </p>
                <p className="mt-1">
                  Email:{" "}
                  <span className="whitespace-nowrap">contact@kissariti.ma</span>
                </p>
              </div>

              <div className="item mt-10">
                <div className="heading4">Heures d'ouverture</div>
                <p className="mt-3">
                  Lun - Ven:{" "}
                  <span className="whitespace-nowrap">7h30 - 20h00 PST</span>
                </p>
                <p className="mt-3">
                  Samedi:{" "}
                  <span className="whitespace-nowrap">8h00 - 18h00 PST</span>
                </p>
                <p className="mt-3">
                  Dimanche:{" "}
                  <span className="whitespace-nowrap">9h00 - 17h00 PST</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactUs;
